@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="w-full mb-2 mt-4 px-2">
      <div class="leading-6 font-medium">{{ field.label | localize }}</div>
      @if (field.hint) {
        <div class="text-md text-secondary">{{ field.hint | localize }}</div>
      }
    </div>
  }
  <div class="flex flex-row flex-wrap items-center w-full border-b p-4 mb-4">
    @if (field?.dTypeForm) {
      <div class="flex flex-row flex-auto flex-wrap w-full">
        @for (column of field.dTypeForm.dType?.column; track column.name) {
          @if (field.dTypeForm.fields[column.name]; as field) {
            @if (!field.hidden) {
              @if (field.browserOpts?.newLine) {
                <div class="w-full"></div>
              }
                            <dtype-item [ngClass]="{
                                    'w-full': field.browserOpts?.width === 'FULL' && field.type !== twoColumnsTable,
                                    'w-1/2': field.browserOpts?.width === 'HALF',
                                    'w-1/3': field.browserOpts?.width === 'THIRD',
                                    'w-2/3': field.browserOpts?.width === 'TWO_THIRDS',
                                    'w-1/4': field.browserOpts?.width === 'FOURTH',
                                    'w-3/4': field.browserOpts?.width === 'THREE_FOURTHS',
                                    'w-1/5': field.browserOpts?.width === 'FIFTH',
                                    'w-2/5': field.browserOpts?.width === 'TWO_FIFTH',
                                    'w-3/5': field.browserOpts?.width === 'THREE_FIFTHS',
                                    'w-4/5': field.browserOpts?.width === 'FOUR_FIFTHS',
                                    'w-1/6': field.browserOpts?.width === 'SIXTH',
                                    'w-5/6': field.browserOpts?.width === 'FIVE_SIXTHS',
                                    'px-2 py-2': !field.hidden && field.type !== embeddedItemUri && field.type !== embeddedItemCollectionUri
                                }" [field]="field" [isUpdate]="isUpdate"></dtype-item>
            }
          }
        }
      </div>
    }
  </div>
}